import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";
import { getIssuanceDetail, getWarehouseKeyValueList } from "../../../services/index";
import AddIcon from "@mui/icons-material/Add";
import Select from "react-select";
import ReceiptIcon from "@mui/icons-material/Receipt";
import PaginationDataTable from "../../Common/PaginationDataTable";
import { ISSUANCE_URL, REQUISITION_URL } from "../../../CONSTANTS";
import Loader from "../../Common/Loader";
import KeyboardReturnIcon from '@mui/icons-material/KeyboardReturn';
import { Modal } from "react-bootstrap";
import ReturnIssuanceModal from "./ReturnIssuanceModal";
import { returnIssuanceUnitEnum } from "../../../services/Inventory/IssuanceService";

const IssuanceList = () => {
    let navigate = useNavigate();
    let location = useLocation();
    let tab = location?.state?.tab;
    const _tab = tab ? tab : "issuance";

    useEffect(() => {
        if (tab !== undefined) {
            navigate(location.requisition, { state: { ...location.state, tab: undefined } });
        }
    }, [tab, location.requisition, location.state]);

    const [activeTab, setActiveTab] = useState(_tab);
    const [issuanceList, setIssuanceList] = useState([]);
    const [filteredIssuanceList, setFilteredIssuanceList] = useState([]);
    const [requisitionList, setRequisitionList] = useState([]);
    const [filteredRequisitionList, setFilteredRequisitionList] = useState([]);
    const [search, setSearch] = useState("");
    const [wareOptions, setWareOptions] = useState(null);
    let [selectedWarehouse, setSelectedWarehouse] = useState({
        value: "",
        label: "Select Warehouse",
    });
    const [warehouseName, setWarehouseName] = useState("");
    const [warehouseId, setWarehouseId] = useState("");
    const [issuanceDetails, setIssuanceDetails] = useState([]);
    const [showReturnIssuanceModal, setShowReturnIssuanceModal] = useState(false);
    const [returnUnits, setReturnUnits] = useState([]);
    const [loading, setLoading] = useState(false);

    const issuanceColumns = [
        {
            name: "ISSUANCE NO.",
            cell: (row) => row.issuanceCode,
            style: { color: "#007bff" }
        },
        {
            name: "REQUISITION NO.",
            cell: (row) => row?.requisitionCode,
            style: { color: "#007bff" }
        },
        {
            name: "ISSUANCE DATE",
            selector: (row) => row.issuanceDate,
        },

        {
            name: "ISSUED BY",
            selector: (row) => row.issuedByUserTitle,
        },
        {
            name: "DEPARTMENT",
            selector: (row) => row.issuedDepartmentTitle,
        },
        {
            name: "ACTIONS",
            selector: (row) => <KeyboardReturnIcon
                style={{ fontSize: '15px', cursor: 'pointer' }}
                titleAccess="Return"
                onClick={() => {
                    getIssueDetails(row.recordId)
                    // navigate('/contacts/' + row.recordId + '/edit');
                }}
            />,
        },
    ];

    const requisitionColumns = [
        {
            name: "STATUS",
            cell: (row) =>
                !row.isAccepted && !row.isRejected ? (
                    <span className="led-orange" title="Pending"></span>
                ) : row.isAccepted && !row.isRejected ? (
                    <span className="led-green" title="Accepted"></span>
                ) : (
                    <span className="led-red" title="Rejected"></span>
                ),
            width: "100px",
        },
        {
            name: "REQUISITION CODE",
            cell: (row) => row.requisitionCode,
            style: { color: "#007bff" }
        },
        {
            name: "WAREHOUSE",
            cell: (row) => row.warehouseTitle,
        },
        {
            name: "DEPARTMENT",
            selector: (row) => row.requestingDepartmentTitle,
        },
        {
            name: "REQUEST DATE",
            selector: (row) => row.requestDate,
        },
        {
            name: "ACTION",
            selector: (row) =>
                !row.isAccepted && !row.isRejected ? (
                    // <div className="d-flex">
                    //     <button className="btn btn-success" onClick={() => handleAcceptRejectRequisition(row.recordId, "accept")}>
                    //         Accept
                    //     </button>
                    //     <button className="ml-2 btn btn-danger" onClick={() => handleAcceptRejectRequisition(row.recordId, "reject")}>
                    //         Reject
                    //     </button>
                    // </div>
                    <ReceiptIcon style={{ cursor: "pointer", align: "right" }} onClick={() => navigate("/issueitems/new", { state: { reqId: row.recordId } })} />
                    // <ReceiptIcon style={{ cursor: "pointer", align: "right" }} onClick={() => navigate("/issueitems/new", { state: { reqId: row.recordId } })} />           
                ) :
                    row.isAccepted && !row.isRejected ?
                        <>Accepted</> : <>Rejected</>

        },
    ];

    useEffect(() => {
        if (!wareOptions) {
            getWarehouseKeyValueList().then((res) => {
                if (res.errorCode === 0) {
                    const options = res.responsePacket?.map((d) => ({
                        value: d.key,
                        label: d.value,
                    }));
                    setWareOptions(options);
                    let data = JSON.parse(localStorage.getItem("ware"));
                    if (data) {
                        setSelectedWarehouse(data);
                        setWarehouseName(data);
                        setWarehouseId(data.value);
                    }
                    else {
                        setSelectedWarehouse(options[0]);
                        setWarehouseName(options[0]);
                        setWarehouseId(options[0].value);
                    }

                } else {
                    toast(res.message);
                }
            });
        }
        getReturnIssueUnitEnum();
    }, []);

    const getIssueDetails = (id) => {
        getIssuanceDetail(id).then((res) => {
            if (res.errorCode === 0) {
                let d1 = res.responsePacket.issuanceDate;
                let dd = new Date(d1).toISOString().replace(/T.*/, '').split('-').reverse().join('-');
                res.responsePacket.issuanceDate = dd;
                setIssuanceDetails(res.responsePacket);
                setShowReturnIssuanceModal(true);
            } else {
                toast.error(res.message);
            }
        });
    };
    
    const getReturnIssueUnitEnum = () => {
        returnIssuanceUnitEnum().then((response) => {
            if (response.errorCode === 0) {
                let res = response.responsePacket;
                setReturnUnits(res.map((item) => ({
                    label: item,
                    value: item
                })))
            } else {
                toast.error(response.message);
            }
        });
    };

    useEffect(() => {
        if (wareOptions) {
            if (activeTab === "issuance") {
                if (filteredIssuanceList && filteredIssuanceList.length > 0) {
                    const result = issuanceList.filter((data) => {
                        return (
                            data.issuanceCode.toLowerCase().includes(search.toLowerCase()) ||
                            data.issuedToUserTitle.toLowerCase().includes(search.toLowerCase()) ||
                            data.issuedByUserTitle.toLowerCase().includes(search.toLowerCase()) ||
                            data.issuedDepartmentTitle.toLowerCase().includes(search.toLowerCase()) ||
                            data.issuanceDate.toLowerCase().includes(search.toLowerCase())
                        );
                    });
                    setFilteredIssuanceList(result);
                }
            } else {
                if (filteredRequisitionList && filteredRequisitionList.length > 0) {
                    const result = requisitionList.filter((data) => {
                        return (
                            data.requestingDepartmentTitle.toLowerCase().includes(search.toLowerCase()) ||
                            data.warehouseTitle.toLowerCase().includes(search.toLowerCase()) ||
                            data.requisitionCode.toLowerCase().includes(search.toLowerCase())
                        );
                    });
                    setFilteredRequisitionList(result);
                }
            }
        }
    }, [search]);

    const handleWarehouseChange = (e) => {
        localStorage.setItem("ware", JSON.stringify(e));
        setWarehouseName(e);
        setWarehouseId(e.value);

    }

    return (
        <>
            <div className="p-4">
                <div className="d-flex justify-content-between align-items-center">
                    <h3 className="mb-0 font-size-18 font-weight-bolder text-uppercase w-100">{activeTab === "issuance" ? "Issuance List" : "Requisition List"}</h3>
                    <ul className="nav nav-tabs font-size-16 w-100 justify-content-end" id="myTab" role="tablist">
                        <li className="nav-item" onClick={() => setActiveTab("issuance")}>
                            <a
                                className={`nav-link ${activeTab === "issuance" ? "active" : ""}`}
                                id="activeList"
                                data-toggle="tab"
                                href="#issuanceList"
                                role="tab"
                                aria-controls="issuanceList"
                                aria-selected="true"
                            >
                                ISSUANCE
                            </a>
                        </li>
                        <li className="nav-item" onClick={() => setActiveTab("requisition")}>
                            <a
                                className={`nav-link ${activeTab === "requisition" ? "active" : ""}`}
                                id="activeList"
                                data-toggle="tab"
                                href="#requisitionList"
                                role="tab"
                                aria-controls="requisitionList"
                                aria-selected="false"
                            >
                                REQUISITION
                            </a>
                        </li>
                    </ul>
                </div>
                <div className="tab-content issuanceList" id="myTabContent">
                    <div className="tab-pane fade show active" id="issuanceList" role="tabpanel" aria-labelledby="activeList">
                        <div className="issuance-warehouse" style={{ zIndex: 6 }}>
                            {/* {activeTab === "issuance" && ( */}
                            <Select
                                options={wareOptions}
                                placeholder={"Select WareHouse"}
                                onChange={(e) => handleWarehouseChange(e)}
                                value={warehouseName}
                                maxMenuHeight={220}
                            />
                            {/* )} */}
                        </div>
                        <div className="excel-postn mt-2">
                            {activeTab === "issuance" ? (
                                <Link to="/issueitems/new">
                                    <button id="ember5839" className="tooltip-container ember-view btn btn-primary d-flex align-items-center" type="button">
                                        <AddIcon />
                                        New
                                    </button>
                                </Link>
                            ) : (
                                <Link to="/requisition/new">
                                    <button id="ember5839" className="tooltip-container ember-view btn btn-primary d-flex align-items-center" type="button">
                                        <AddIcon />
                                        New
                                    </button>
                                </Link>
                            )
                            }
                        </div>
                        {activeTab === "issuance" ? (
                            (filteredIssuanceList && warehouseId) && (
                                <PaginationDataTable
                                    paginationUrl={ISSUANCE_URL() + "getAllRecords"}
                                    serverSidePagination={true}
                                    search={true}
                                    pagination={false}
                                    className="position-relative customDataTable"
                                    columns={issuanceColumns}
                                    showNewBtn={true}
                                    onRowClicked={(data) => navigate(`/issueitems/${data.recordId}`, { state: { ware: warehouseName } })}
                                    filter={{
                                        uuid2: warehouseId,
                                    }}
                                    loading={true}
                                />
                            )
                        ) : (
                            <>
                                {filteredRequisitionList && (
                                    <PaginationDataTable
                                        paginationUrl={REQUISITION_URL() + "getAllRecords"}
                                        serverSidePagination={true}
                                        pagination={false}
                                        className="position-relative"
                                        columns={requisitionColumns}
                                        showNewBtn={true}
                                        onRowClicked={(data) => navigate(`/requisition/${data.recordId}`)}
                                        filter={{
                                            uuid2: warehouseId,
                                        }}
                                        loading={true}
                                        search={true}
                                    />

                                )}
                            </>
                        )}
                    </div>
                </div>
            </div>
            <Modal show={showReturnIssuanceModal} onHide={() => setShowReturnIssuanceModal(false)} size="lg">
                <Modal.Header>Return Item Form</Modal.Header>
                <Modal.Body>
                        <ReturnIssuanceModal issuanceDetails={issuanceDetails} returnUnits={returnUnits} onClose={() => setShowReturnIssuanceModal(false)}/>
                </Modal.Body>
            </Modal>
            <Toaster />
        </>
    );
};

export default IssuanceList;
